import { createFileRoute } from "@tanstack/react-router";
import { pageTitle } from "@/components/document-title";
import { BillingPage } from "@/features/onboarding/pages/billing-page";

export const Route = createFileRoute("/onboarding/_guarded/billing")({
	head: () => pageTitle("Billing Information"),
	component: BillingPage,
});
